<template>
  <div>
    <div class="bg-section-projects">
      <v-col
        lg="5"
        md="10"
      >
        <div class="pl-10 pt-10 pb-10 pr-10">
          <v-stepper
            v-model="workorCheckIn"
            light
            class="my-stepper-style"
            elevation="0"
          >
            <v-stepper-header>
              <v-stepper-step
                :complete="workorCheckIn > 1"
                step="1"
                color="#37474F"
              />

              <v-divider />

              <v-stepper-step
                :complete="workorCheckIn > 2"
                step="2"
                color="#37474F"
              />
            </v-stepper-header>
          </v-stepper>
          <select-work-types
            v-if="showSelectWorkTypes"
            @selected-work-type="toSecondStep"
            @cancel="toCheckOutOrCostShift"
          />
          <review-details
            v-if="showReviewDetails"
            :button-text="'Shift'"
            @cancel="toFirstStep"
          />
        </div>
      </v-col>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from '../../../components/SpinnerCentre.vue';
import SelectWorkTypes from './SelectWorkTypes.vue';
import ReviewDetails from './ReviewDetails.vue';
export default {
  name: 'HomePage',
  components: {
    'centre-spinner': spinner,
    'select-work-types': SelectWorkTypes,
    'review-details': ReviewDetails,
  },
  data () {
    return {
      loading: false,
      step1SuccessColor: '',
      showSelectWorkTypes: true,
      step2SuccessColor: '',
      showReviewDetails: false,
      workorCheckIn: 1,
      user: {},
    };
  },
  computed: {
    step1Success () {
      return `color:${this.step1SuccessColor}`;
    },
    step2Success () {
      return `color:${this.step2SuccessColor}`;
    },
    appUserCheckInRecord () {
      return this.$store.getters['devices/getActiveCheckInDetails'];
    },
  },
  mounted () {
    this.checkUserExist();
  },
  methods: {
    async checkUserExist () {
      this.user = localStorage.getItem('worker');
      if (this.user === null) {
        this.$router.push({ name: 'DeviceCheckInCheckOut' });
        return;
      }
      await this.getCheckInRecords();
      },
    toFirstStep () {
      this.showSelectWorkTypes = true;
      this.showReviewDetails = false;
      this.step1SuccessColor = '#00796B';
      this.workorCheckIn = 1;
    },
    toSecondStep () {
      this.showSelectWorkTypes = false;
      this.showReviewDetails = true;
      this.step1SuccessColor = '#00796B';
      this.workorCheckIn = 2;
    },
    toCheckOutOrCostShift () {
        setTimeout(() => {
            this.$router.push({ name: 'DeviceCheckOutCostShift' });
        }, 1000);
    },
    toCheckInSuccess () {
      setTimeout(() => {
        this.$router.push({ name: 'CheckIn' });
      }, 1000);
    },
    async getCheckInRecords () {
  try {
    await this.$store.dispatch('devices/fetchUsersCurrentCheckInDetails');
    if (Object.keys(this.appUserCheckInRecord).length === 0) {
      this.$router.push({ name: 'DeviceSelectProject' });
    }
  } catch (error) {
    this.$router.push({ name: 'DeviceCheckInCheckOut' });
  }
},

  },
};
</script>

<style scoped>
.v-stepper__header {
  background: #f5f5f5;
}

.v-stepper__step {
  padding: 10px;
}

.v-stepper__header .v-divider {
  margin: 0 3px;
}
</style>
